import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import { 
  Heart, 
  Scale, 
  Users, 
  Award, 
  Shield, 
  MessageCircle, 
  HandHeart, 
  Trophy,
  Phone,
  Mail,
  MapPin,
  Facebook,
  X,
  
  Menu,
  XIcon,
  Code2,
  Music,
  Languages,
  Hammer,
  Palette,
  BookOpen,
  CheckCircle2
} from "lucide-react";
import { ImageGallery } from "./components/ImageGallery";
import { AnimatedBackground } from "./components/AnimatedBackground";
import { HeroSlider } from "./components/HeroSlider";
import { ContactForm } from "./components/ContactForm";
import { AdmissionModal } from "./components/AdmissionModal";
import directorImage from "../assets/img/director.jpeg";
import beautyImage from "../assets/img/beauty efoma.jpeg";
import pastorImage from "../assets/img/pastor tope.jpeg";
import logo from "../assets/img/logo-main.jpg";

// Change this URL to the specific embed URL you want to use
const mapEmbedUrl = "https://www.google.com/maps?q=No%209%20Saint%20Michael%27s%20Street%20Port%20Harcourt&output=embed";

const coreValues = [
  {
    icon: Heart,
    title: "Caring",
    description: "We nurture every individual in a safe, supportive, and inclusive environment where everyone feels valued.",
    color: "from-pink-500 to-rose-500"
  },
  {
    icon: Scale,
    title: "Fairness",
    description: "We uphold equity and justice, ensuring that all are treated impartially and with dignity.",
    color: "from-blue-500 to-cyan-500"
  },
  {
    icon: Users,
    title: "Citizenship",
    description: "We promote responsible citizenship by encouraging positive contributions to our school, community, and society at large.",
    color: "from-green-500 to-emerald-500"
  },
  {
    icon: Award,
    title: "Responsibility",
    description: "We foster accountability and self-discipline, empowering individuals to take ownership of their actions and learning.",
    color: "from-purple-500 to-violet-500"
  },
  {
    icon: Shield,
    title: "Trustworthiness",
    description: "We build strong relationships grounded in reliability, transparency, and mutual confidence.",
    color: "from-indigo-500 to-blue-500"
  },
  {
    icon: MessageCircle,
    title: "Honesty",
    description: "We encourage integrity and truthfulness in all interactions and decisions.",
    color: "from-amber-500 to-orange-500"
  },
  {
    icon: HandHeart,
    title: "Respect",
    description: "We value diversity and uphold respect for oneself, others, and the environment.",
    color: "from-teal-500 to-cyan-500"
  },
  {
    icon: Trophy,
    title: "Excellence",
    description: "We strive for the highest standards in teaching, learning, and personal development.",
    color: "from-yellow-500 to-amber-500"
  }
];

const galleryImages = [
  // Local Images - Activities
  { url: "/img/1.jpeg", category: "activities", title: "School Activity 1" },
  { url: "/img/2.jpeg", category: "activities", title: "School Activity 2" },
  { url: "/img/3.jpeg", category: "activities", title: "School Activity 3" },
  { url: "/img/4.jpeg", category: "activities", title: "School Activity 4" },
  { url: "/img/5.jpeg", category: "activities", title: "School Activity 5" },
  { url: "/img/6.jpeg", category: "activities", title: "School Activity 6" },
  { url: "/img/7.jpeg", category: "activities", title: "School Activity 7" },
  { url: "/img/8.jpeg", category: "activities", title: "School Activity 8" },
  { url: "/img/9.jpeg", category: "activities", title: "School Activity 9" },
  { url: "/img/10.jpeg", category: "activities", title: "School Activity 10" },
  { url: "/img/12.jpeg", category: "activities", title: "School Activity 11" },
  { url: "/img/13.jpeg", category: "activities", title: "School Activity 12" },
  { url: "/img/14.jpeg", category: "activities", title: "School Activity 13" },
  { url: "/img/15.jpeg", category: "activities", title: "School Activity 14" },
  { url: "/img/16.jpeg", category: "activities", title: "School Activity 15" },
  { url: "/img/17.jpeg", category: "activities", title: "School Activity 16" },
  { url: "/img/18.jpeg", category: "activities", title: "School Activity 17" },
  { url: "/img/19.jpeg", category: "activities", title: "School Activity 18" },
  { url: "/img/20.jpeg", category: "activities", title: "School Activity 19" },
  { url: "/img/22.jpeg", category: "activities", title: "School Activity 20" },
  { url: "/img/23.jpeg", category: "activities", title: "School Activity 21" },
  { url: "/img/24.jpeg", category: "activities", title: "School Activity 22" },
  { url: "/img/25.jpeg", category: "activities", title: "School Activity 23" },
  { url: "/img/26.jpeg", category: "activities", title: "School Activity 24" },
  { url: "/img/27.jpeg", category: "activities", title: "School Activity 25" },
  { url: "/img/28.jpeg", category: "activities", title: "School Activity 26" },
  { url: "/img/29.jpeg", category: "activities", title: "School Activity 27" },
  { url: "/img/31.jpeg", category: "activities", title: "School Activity 28" },
  { url: "/img/32.jpeg", category: "activities", title: "School Activity 29" },
  { url: "/img/33.jpeg", category: "activities", title: "School Activity 30" },
  // Local Images - Events
  { url: "/img/34.jpeg", category: "events", title: "School Event 1" },
  { url: "/img/35.jpeg", category: "events", title: "School Event 2" },
  { url: "/img/36.jpeg", category: "events", title: "School Event 3" },
  { url: "/img/37.jpeg", category: "events", title: "School Event 4" },
  { url: "/img/38.jpeg", category: "events", title: "School Event 5" },
  { url: "/img/39.jpeg", category: "events", title: "School Event 6" },
  { url: "/img/40.jpeg", category: "events", title: "School Event 7" },
  { url: "/img/41.jpeg", category: "events", title: "School Event 8" },
  { url: "/img/42.jpeg", category: "events", title: "School Event 9" },
  { url: "/img/44.jpeg", category: "events", title: "School Event 10" },
  { url: "/img/45.jpeg", category: "events", title: "School Event 11" },
  { url: "/img/46.jpeg", category: "events", title: "School Event 12" },
  { url: "/img/47.jpeg", category: "events", title: "School Event 13" },
  { url: "/img/48.jpeg", category: "events", title: "School Event 14" },
  { url: "/img/49.jpeg", category: "events", title: "School Event 15" },
  { url: "/img/50.jpeg", category: "events", title: "School Event 16" },
  { url: "/img/52.jpeg", category: "events", title: "School Event 17" },
  { url: "/img/53.jpeg", category: "events", title: "School Event 18" },
  { url: "/img/54.jpeg", category: "events", title: "School Event 19" },
  { url: "/img/55.jpeg", category: "events", title: "School Event 20" },
  { url: "/img/56.jpeg", category: "events", title: "School Event 21" },
  { url: "/img/57.jpeg", category: "events", title: "School Event 22" },
  { url: "/img/58.jpeg", category: "events", title: "School Event 23" },
  { url: "/img/59.jpeg", category: "events", title: "School Event 24" },
  { url: "/img/60.jpeg", category: "events", title: "School Event 25" },
  { url: "/img/61.jpeg", category: "events", title: "School Event 26" },
  { url: "/img/62.jpeg", category: "events", title: "School Event 27" },
  { url: "/img/63.jpeg", category: "events", title: "School Event 28" },
  { url: "/img/64.jpeg", category: "events", title: "School Event 29" },
  { url: "/img/65.jpeg", category: "events", title: "School Event 30" },
  { url: "/img/66.jpeg", category: "events", title: "School Event 31" },
  { url: "/img/67.jpeg", category: "events", title: "School Event 32" },
  { url: "/img/68.jpeg", category: "events", title: "School Event 33" },
  { url: "/img/69.jpeg", category: "events", title: "School Event 34" },
  { url: "/img/303.jpeg", category: "events", title: "School Event 35" }
];

const specialPrograms = [
  {
    icon: Code2,
    title: "Coding & Robotics",
    description: "Introduction to programming and computational thinking to prepare students for the digital age.",
    color: "from-blue-500 to-cyan-500",
    image: "https://images.unsplash.com/photo-1638452033979-14fba9e17fbb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMGNvZGluZyUyMHByb2dyYW1taW5nJTIwY2xhc3N8ZW58MXx8fHwxNzcwNzkwMzA1fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
  },
  {
    icon: Music,
    title: "Music & Arts",
    description: "Develop musical talents and creativity through lessons in various instruments and vocal training.",
    color: "from-purple-500 to-pink-500",
    image: "https://images.unsplash.com/photo-1554343594-1c9d305bd51f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxraWRzJTIwbXVzaWMlMjBsZXNzb25zJTIwaW5zdHJ1bWVudHN8ZW58MXx8fHwxNzcwNzkwMzA1fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
  },
  {
    icon: Languages,
    title: "French Language",
    description: "Learn French through interactive and engaging lessons that build communication skills.",
    color: "from-indigo-500 to-blue-500",
    image: "https://images.unsplash.com/photo-1707273549945-62138ce5aafb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMGxlYXJuaW5nJTIwZnJlbmNoJTIwbGFuZ3VhZ2V8ZW58MXx8fHwxNzcwNzkwMzA2fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
  },
  {
    icon: Hammer,
    title: "DIY & Crafts",
    description: "Hands-on activities that encourage creativity, problem-solving, and practical skills.",
    color: "from-orange-500 to-red-500",
    image: "https://images.unsplash.com/photo-1766932901295-d4185660341b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxraWRzJTIwY3JhZnQlMjBESVklMjBhY3Rpdml0aWVzfGVufDF8fHx8MTc3MDc5MDMwNnww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
  },
  {
    icon: Palette,
    title: "Visual Arts",
    description: "Explore drawing, painting, and other artistic mediums to express creativity.",
    color: "from-pink-500 to-rose-500",
    image: "https://images.unsplash.com/photo-1587616211892-f743fcca64f9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxudXJzZXJ5JTIwc2Nob29sJTIwY2hpbGRyZW4lMjBhY3Rpdml0aWVzfGVufDF8fHx8MTc3MDcwNDU2OHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
  },
  {
    icon: BookOpen,
    title: "Reading Club",
    description: "Foster a love for reading and literacy through engaging stories and book discussions.",
    color: "from-green-500 to-teal-500",
    image: "https://images.unsplash.com/photo-1607823477653-e2c3980acb86?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHJlYWRpbmclMjBib29rcyUyMGxpYnJhcnl8ZW58MXx8fHwxNzcwNTk5MzI5fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
  }
];

export default function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [admissionModalOpen, setAdmissionModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-x-hidden">
      <AnimatedBackground />
      
      <AdmissionModal isOpen={admissionModalOpen} onClose={() => setAdmissionModalOpen(false)} />
      
      {/* Navigation */}
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur-md shadow-2xl" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-3 cursor-pointer"
              onClick={() => scrollToSection("hero")}
            >
              <div className="p-0 rounded-lg overflow-hidden bg-white/0">
                <img src={logo} alt="Uckfield logo" className="w-10 h-10 object-contain" />
              </div>
              <span className={`text-xl transition-colors ${scrolled ? "text-gray-900" : "text-white"}`}>
                Uckfield International School
              </span>
            </motion.div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              {["About", "Programs", "Gallery", "Contact", "Portal"].map((item) => (
                <motion.button
                  key={item}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    if (item === "Portal") {
                      const newWindow = window.open('https://uis.schoolrun.xyz', '_blank', 'noopener,noreferrer');
                      if (newWindow) newWindow.opener = null;
                    } else {
                      scrollToSection(item.toLowerCase());
                    }
                  }}
                  className={`transition-colors ${
                    scrolled ? "text-gray-900 hover:text-blue-600" : "text-white hover:text-blue-200"
                  }`}
                >
                  {item}
                </motion.button>
              ))}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setAdmissionModalOpen(true)}
                className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all"
              >
                Enroll Now
              </motion.button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? (
                <XIcon className={scrolled ? "text-gray-900" : "text-white"} />
              ) : (
                <Menu className={scrolled ? "text-gray-900" : "text-white"} />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden bg-white/95 backdrop-blur-md"
            >
              <div className="px-4 py-4 space-y-3">
                { ["About", "Programs", "Gallery", "Contact", "Portal"].map((item) => (
                  <button
                    key={item}
                    onClick={() => {
                      if (item === "Portal") {
                        setMobileMenuOpen(false);
                        const newWindow = window.open('https://uis.schoolrun.xyz', '_blank', 'noopener,noreferrer');
                        if (newWindow) newWindow.opener = null;
                      } else {
                        setMobileMenuOpen(false);
                        scrollToSection(item.toLowerCase());
                      }
                    }}
                    className="block w-full text-left px-4 py-2 text-gray-900 hover:bg-blue-50 rounded-lg transition-colors"
                  >
                    {item}
                  </button>
                ))}
                <button
                  onClick={() => {
                    setMobileMenuOpen(false);
                    setAdmissionModalOpen(true);
                  }}
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-2 rounded-lg shadow-lg"
                >
                  Enroll Now
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.nav>

      {/* Hero Slider Section */}
      <section id="hero">
        <HeroSlider />
      </section>

      {/* Admission Banner */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500"
      >
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="text-white">
              <div className="flex items-center gap-3 mb-4">
                <CheckCircle2 className="size-8 animate-pulse" />
                <h3 className="text-3xl sm:text-4xl">Applications Now Open!</h3>
              </div>
              <p className="text-xl text-white/90 mb-2">
                Join the Uckfield International School family for the 2026/2027 academic session
              </p>
              <p className="text-white/80">
                Limited slots available. Enroll your child today for quality education.
              </p>
            </div>
            <motion.button
              whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(0,0,0,0.3)" }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setAdmissionModalOpen(true)}
              className="bg-white text-green-600 px-8 py-4 rounded-full shadow-2xl hover:bg-gray-50 transition-all whitespace-nowrap"
            >
              Enroll Now
            </motion.button>
          </div>
        </div>
      </motion.section>

      {/* About the School & Leadership Section */}
      <section id="about" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-white/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          {/* Mission Statement */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-20"
          >
            <h2 className="text-4xl sm:text-5xl text-gray-900 mb-6">About Our School</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mb-8"></div>
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
              Uckfield International School is a nursery and primary institution dedicated to nurturing young minds 
              and developing future leaders through the provision of qualified teachers, a rich curriculum, and standard 
              educational facilities and activities. At Uckfield International School, every child matters and is given 
              the attention and support needed to thrive academically and morally.
            </p>
          </motion.div>

          {/* Leadership Team */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mb-16"
          >
            <h3 className="text-3xl sm:text-4xl text-gray-900 text-center mb-12">Our Leadership Team</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
              {/* Founding Director (moved first) */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                whileHover={{ y: -10 }}
                className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={pastorImage}
                    alt="Founding Director"
                    loading="lazy"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 text-center">
                  <div className="inline-block bg-gradient-to-r from-indigo-500 to-blue-600 text-white px-4 py-1 rounded-full text-sm mb-3">
                    Founding Director
                  </div>
                  <h4 className="text-2xl text-gray-900 mb-2">Pst Tope Ajanaku</h4>
                  <p className="text-gray-600">Guiding academic excellence</p>
                </div>
              </motion.div>

              {/* Co Director (moved second) */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                whileHover={{ y: -10 }}
                className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={directorImage}
                    alt="Co Director"
                    loading="lazy"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 text-center">
                  <div className="inline-block bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-1 rounded-full text-sm mb-3">
                    Co Director
                  </div>
                  <h4 className="text-2xl text-gray-900 mb-2">Pst Charles Egegbula</h4>
                  <p className="text-gray-600">Leading with vision and dedication</p>
                </div>
              </motion.div>

              {/* Administrator */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                whileHover={{ y: -10 }}
                className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={beautyImage}
                    alt="Administrator"
                    loading="lazy"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 text-center">
                  <div className="inline-block bg-gradient-to-r from-orange-500 to-amber-600 text-white px-4 py-1 rounded-full text-sm mb-3">
                    Administrator
                  </div>
                  <h4 className="text-2xl text-gray-900 mb-2">Beauty Efoma Eloho</h4>
                  <p className="text-gray-600">Nurturing excellence in education</p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Core Values Section */}
      <section id="values" className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl sm:text-5xl text-white mb-6">Our Core Values</h2>
            <div className="w-24 h-1 bg-white mx-auto mb-8"></div>
            <p className="text-lg sm:text-xl text-white/90 max-w-3xl mx-auto">
              At the heart of our institution are values that guide our actions, shape our culture, 
              and define our commitment to excellence.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {coreValues.map((value, index) => (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ 
                  y: -10,
                  transition: { duration: 0.3 }
                }}
                className="group relative"
              >
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 h-full">
                  <div className={`bg-gradient-to-br ${value.color} p-4 rounded-xl inline-block mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <value.icon className="size-8 text-white" />
                  </div>
                  <h3 className="text-xl text-gray-900 mb-3">{value.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{value.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Special Programs Section */}
      <section id="programs" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-white/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h2 className="text-4xl sm:text-5xl text-gray-900 mb-6">Special Programs</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mb-8"></div>
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
              Our school offers a variety of special programs designed to enrich the educational experience and 
              develop a well-rounded skill set in our students.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
            {specialPrograms.map((program, index) => (
              <motion.div
                key={program.title}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ 
                  y: -10,
                  transition: { duration: 0.3 }
                }}
                className="group relative"
              >
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 h-full">
                  <div className={`bg-gradient-to-br ${program.color} p-4 rounded-xl inline-block mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <program.icon className="size-8 text-white" />
                  </div>
                  <h3 className="text-xl text-gray-900 mb-3">{program.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{program.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl sm:text-5xl text-white mb-6">Our School Life</h2>
            <div className="w-24 h-1 bg-white mx-auto mb-8"></div>
            <p className="text-lg sm:text-xl text-white/90 max-w-3xl mx-auto">
              Explore moments of learning, growth, and joy at Uckfield International School
            </p>
          </motion.div>

          <ImageGallery images={galleryImages} />
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-white/80 backdrop-blur-sm">
          <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl sm:text-5xl text-gray-900 mb-6">Get In Touch</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mb-8"></div>
          </motion.div>

          {/* Map Embed: change `mapEmbedUrl` above to embed a different location */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mb-8"
          >
            <div className="w-full rounded-2xl overflow-hidden shadow-xl">
              <iframe
                title="Uckfield Location"
                src={mapEmbedUrl}
                className="w-full h-64 md:h-96 border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-3 rounded-lg">
                  <MapPin className="size-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl text-gray-900 mb-2">Address</h3>
                  <p className="text-gray-600">
                    No 9, Saint Michael's Street, off Iwofe Road, by St Michael's Bus Stop, Port Harcourt.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-3 rounded-lg">
                  <Phone className="size-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl text-gray-900 mb-2">Phone</h3>
                  <a href="tel:+2347036853581" className="text-blue-600 hover:underline">07036853581</a>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-gradient-to-br from-pink-500 to-rose-600 p-3 rounded-lg">
                  <Mail className="size-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl text-gray-900 mb-2">Email</h3>
                  <a href="mailto:uckfieldschool@gmail.com" className="text-blue-600 hover:underline">
                    uckfieldschool@gmail.com
                  </a>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-3 rounded-lg">
                  <Facebook className="size-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl text-gray-900 mb-2"><a href="https://www.facebook.com/share/1Autpgqca8/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      Facebook
                    </a></h3>
                  <p className="text-gray-600">
                    <a href="https://www.facebook.com/share/1Autpgqca8/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      Uckfield International School
                    </a>
                  </p>
                  <p className="text-gray-600">Uckfield Intl Sch</p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Contact Form */}
          <ContactForm />
        </div>
      </section>

      {/* Footer */}
      <footer className="relative py-8 px-4 sm:px-6 lg:px-8 bg-gray-900/90 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-white/80">
            © 2026 Uckfield International School. All rights reserved.
          </p>
          <p className="text-white/60 mt-2">
            Every child matters. Building future leaders.
          </p>
        </div>
      </footer>
    </div>
  );
}